import React, { useEffect, useState } from 'react';
import { naac, grade, nba } from '../../assets/index';
import { getRecognitionsAndApprovals } from '../../services/getAllApi';

const ApprovalCard = ({ image, title, subtitle, isBottomRow }) => {
  return (
    <div className="border border-gray-300 flex flex-col items-center p-4 transform transition-all duration-300 hover:shadow-xl hover:scale-105 hover:border-[#EC8305] bg-white rounded-md">
      <img
        src={image}
        alt="Approval"
        className="h-[8rem] sm:h-[10rem] md:h-[13rem] w-auto object-contain transition-transform duration-300 hover:scale-110"
      />
      <div className="bg-[#000080] w-full mt-4 flex items-center justify-center p-2 transition-colors duration-300 hover:bg-[#000065]">
        <p className="text-white text-center text-sm sm:text-base md:text-lg font-semibold">
          {title}
        </p>
      </div>
      {isBottomRow && (
        <div className="w-full mt-4 flex items-center justify-center transform transition-all duration-300 hover:text-[#EC8305]">
          <p className="text-center font-bold px-2">{subtitle}</p>
        </div>
      )}
    </div>
  );
};

const Approvals = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRecognitionsAndApprovals();
        setItems(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-full bg-white text-justify">
      {/* 🔶 Responsive Hero Section */}
      <div
        className="relative w-full h-[20rem] sm:h-[25rem] md:h-[30rem] flex flex-col items-center justify-center text-center bg-cover bg-center px-4 sm:px-8 animate-fadeIn"
        style={{
          backgroundImage:
            "url('https://media.istockphoto.com/id/1950017540/photo/gold-trophy-with-a-row-of-gold-trophy-background.webp?b=1&s=612x612&w=0&k=20&c=ZxMrSgBN9Pm7QoObFQwErN8IDh_l8x8Ih1mVF6O47Tg=')",
        }}
      >
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-[#EC8305] bg-[#000000cc] px-4 py-2 rounded animate-fadeIn mb-2">
          Recognition and Approvals
        </h1>

        <div className="w-40 sm:w-60 md:w-[30rem] h-[0.09rem] bg-[#EC8305] animate-expand" />
      </div>

      {/* 🔶 Approval Cards Section */}
      <div className="px-4 sm:px-6 md:px-10 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items?.length > 0 &&
            items.map((item) => (
              <ApprovalCard
                key={item.id}
                image={`${process.env.REACT_APP_IMGURL}/${item.image}`}
                title={item.description}
              />
            ))}

          {/* Fallback or Static Approvals */}
          <ApprovalCard
            image={nba}
            title={
              <>
                Accredited by <span className="text-orange-300">AICTE</span>
              </>
            }
          />
          <ApprovalCard
            image={naac}
            title={
              <>
                Accredited by <span className="text-orange-300">NAAC</span>
              </>
            }
          />
          <ApprovalCard
            image={grade}
            title={
              <>
                Accredited by <span className="text-orange-300">UGC</span>
              </>
            }
          />
        </div>
      </div>

      {/* 🔶 Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes expand {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 1s ease-out;
        }

        .animate-expand {
          animation: expand 1.5s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Approvals;
